import { useEffect, useState } from 'react';
import { useRouter } from 'next/router';
import { Box } from '@mui/material';
import { ThemeProvider } from '@mui/material/styles';
import PrismaNavigationBar from './components/PrismaNavigationBar';
import PrismaFooter from './components/PrismaFooter';
import { prismaTheme } from '@/components/shared/theme/prisma-theme';
import { PrismaProvider } from './context/PrismaContext';
import { Rutas } from '@/constants/rutas';

const PrismaMainLayout = ({ children }) => {
    const router = useRouter();

    const [currentCategory, setCurrentCategory] = useState(null);

    useEffect(() => {
        const path = (router.asPath || '').split('?')[0];
        const parts = path.split('/').filter(Boolean);
        const prismaIdx = parts.indexOf('prisma');
        if (prismaIdx !== -1) {
            const maybeSection = parts[prismaIdx + 1];
            const maybeCategory = parts[prismaIdx + 2];
            if (maybeSection === 'categoria' && maybeCategory) {
                setCurrentCategory(maybeCategory);
            } else {
                setCurrentCategory(null);
            }
        } else {
            setCurrentCategory(null);
        }
    }, [router.asPath]);

    // Funciones de navegación
    const handleNavigateHome = () => router.push(Rutas.PRISMA);
    const handleNavigateCategory = (categoria) => router.push(Rutas.PRISMA_CATEGORIA(categoria));

    return (
        <PrismaProvider>
            <ThemeProvider theme={prismaTheme}>
                <Box
                    sx={{
                        minHeight: '100vh',
                    }}
                >
                    {/* Barra de navegación */}
                    <PrismaNavigationBar
                        currentCategory={currentCategory}
                        onNavigateHome={handleNavigateHome}
                        onNavigateCategory={handleNavigateCategory}
                    />

                    {/* Contenido principal */}
                    <Box
                        component="main"
                        sx={{
                            px: { xs: '8px', md: '0' },
                            py: 2,
                        }}
                    >
                        {children}
                    </Box>

                    {/* Footer */}
                    <PrismaFooter />
                </Box>
            </ThemeProvider>
        </PrismaProvider>
    );
};

export default PrismaMainLayout;
